<template>
	<div class="modal fade" id="createCollaborator" data-backdrop="false" tabindex="-1" role="dialog"
		aria-labelledby="editRecord" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title d-inline">Add a collaborator</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<form @submit.prevent="create">
					<div class="modal-body">
						<div class="form-group row">
							<div class="col-sm-12">
								<input type="email" v-validate="'required|email'"
									:class="{'form-control': true, 'is-invalid': formErrors.has('Email ID') }"
									v-model="email" name="Email ID" required placeholder="Enter Email">
								<div v-if="formErrors.has('Email')" class="invalid-feedback">
									{{formErrors.first('Email ID')}}
								</div>
							</div>
						</div>
						<div class="form-check" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input class="form-check-input" type="checkbox" v-model="allowAll" />
								Access to all domains
								<span class="form-check-sign"></span>
							</label>
						</div>
						<div class="mb-2"><b>OR</b></div>
						<div class="form-group">
							<multiselect v-model="selectedDomains" :options="domains" :multiple="true"
									:close-on-select="false" :disabled="allowAll"
									:clear-on-select="true" placeholder="Select Desired Domain (s)"/>
						</div>
						<h4>Access Level: </h4>
						<div class="form-check" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input class="form-check-input" type="checkbox" value="full" v-model="accessLevels" />
								Full Access
								<span class="form-check-sign"></span>
								<span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Pushing and pulling between staging and live, as well as adjusting DNS or redirects are only available with full access." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>
							</label>
						</div>
						<div :class="(accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input :disabled="accessLevels.includes('full')" class="form-check-input" type="checkbox" value="live" v-model="accessLevels" />
								Live Details
								<span class="form-check-sign"></span>
							</label>
						</div>
						<div :class="(accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input :disabled="accessLevels.includes('full')" class="form-check-input" type="checkbox" value="staging" v-model="accessLevels" />
								Staging Details
								<span class="form-check-sign"></span>
							</label>
						</div>
						<div :class="(accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input :disabled="accessLevels.includes('full')" class="form-check-input" type="checkbox" value="installation" v-model="accessLevels" />
								New WP installation or migration requests
								<span class="form-check-sign"></span>
							</label>
						</div>
						<div :class="(accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
							<label class="form-check-label">
								<input :disabled="accessLevels.includes('full')" class="form-check-input" type="checkbox" value="tickets" v-model="accessLevels" />
								All support tickets
								<span class="form-check-sign"></span>
							</label>
						</div>
					</div>
					<div class="modal-footer">
						<button type="submit" class="btn btn-primary" :disabled="isBtnDisabled">
							<div class="loader mini_loader" v-if="action === 'create'"></div>
							<span v-else>Send</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>


<script>
	import {db} from "@/firebase/init";
	import swal from "sweetalert2";
	import Multiselect from 'vue-multiselect'
	import 'vue-multiselect/dist/vue-multiselect.min.css';
	import crypto from 'crypto-js';
	export default {
		name: "CollaboratorCreateModal",
		data: function () {
			return {
				email: '',
				action: null,
				selectedDomains: [],
				allowAll: true,
				accessLevels: []
			}
		},
		components: {Multiselect},
		computed: {
			isBtnDisabled () {
				return this.email === '' || ((!this.selectedDomains || this.selectedDomains.length === 0) && !this.allowAll) || this.accessLevels.length === 0;
			},
			user() {
				return this.$store.getters.user;
			},
			domains() {
				const accounts = this.$store.getters['hosting/accounts'];
				if(accounts === undefined) {
					return [];
				}
				let domains = [];
				for(const account of accounts){
					domains.push(account.primary.domain);
					for(let adon of account.addon){
						domains.push(adon.domain);
					}
				}
				return domains;
			},
			aesSecret() {
				return this.$store.getters["crypto/aesSecret"];
			}
		},
    watch: {
      email (value) {
        this.email = value.toLowerCase();
      }
    },
		methods: {
			create() {
				if(this.accessLevels.includes('full')) {
					this.accessLevels = this.accessLevels.filter(level => level === 'full');
					console.log(this.accessLevels);
				}
				if(this.domains.length === 0) {
					swal({
						title: "No Active Domain!",
						text: "You must have at least one active domain to add the collaborator.",
						type: "error",
						confirmButtonText: "OK!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				if(this.accessLevels.length === 0) {
					swal({
						title: "Invalid Access Level!",
						text: "Please select at least one access level.",
						type: "error",
						confirmButtonText: "OK!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				if(this.email === ''){
					swal({
						title: "Something went wrong!",
						text: "Please enter the correct email",
						type: "error",
						confirmButtonText: "Try Again!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				if(this.email === this.user.email){
					swal({
						title: "Something went wrong!",
						text: "You cannot use your email",
						type: "error",
						confirmButtonText: "Try Again!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				let htmlList = "<br/><ul style='text-align: justify; font-weight: bold;list-style: none'>";
				for(const domain of this.selectedDomains){
					htmlList += `<li>${domain}</li>`;
				}
				htmlList += "</ul>";
				let htmlMessage = "You are about to give <b>" + this.email + "</b> complete access to the following domains:" + htmlList;
				if(this.allowAll){
					htmlMessage = "You are about to give <b>" + this.email + "</b> complete access to all your domains.";
				}
				swal({
					title: "Caution! ",
					html: htmlMessage,
					type: "warning",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				}).then(async result => {
					if(result.value){
						this.$validator.validateAll().then(async (result) => {
							if (result) {
								this.action = 'create';
								let isSignUp = '0';
								let collabUid = '';
								let collabName = '';
								let collabSupervisors = null;
								if(this.allowAll) {
									for(const domain of this.domains) {
										if(domain !== '') {
											this.selectedDomains.push(domain);
										}
									}
								}
								const collaboratorRef = await db.collection('users').doc(this.user.uid).get();
								const allCollaborators = collaboratorRef.data()['collaborators'];
								if(allCollaborators !== undefined){
									for(let collaborator of allCollaborators){
										if(collaborator.email.trim().toLowerCase() === this.email.trim().toLowerCase()){
											swal('Already Exist!', 'You have already added this collaborator.', 'warning');
											this.action = null;
											return;
										}
									}
								}

								const isUserExist = await db.collection('users').where('email', '==', this.email).get();
								if(isUserExist.empty){
									isSignUp = '1';
								}else{
									isUserExist.forEach(doc => {
										collabUid = doc.id;
										collabName = doc.data()['firstName'] + ' ' + doc.data()['lastName'];
										collabSupervisors = doc.data()['supervisors'];
									});
									if(collabSupervisors === undefined){
										collabSupervisors = [];
									}
									collabSupervisors.push({
										supervisorId: this.user.uid,
										allowedDomains: this.selectedDomains,
										accessLevels: this.accessLevels,
										allowAll: this.allowAll,
										created: new Date().toISOString(),
										supervisorEmail: this.user.email,
										supervisorName: this.user.firstName + ' ' + this.user.lastName,
										status: 'pending'
									});
									await db.collection('users').doc(collabUid).update({
										supervisors: collabSupervisors
									});
								}
								console.log('IsIgnUp: ' + isSignUp);
								db.collection('users').doc(this.user.uid).get().then(async (doc) => {
									const userData = doc.data();
									if(userData.collaborators === undefined){
										userData.collaborators = []
									}
									userData.collaborators.push({
										email: this.email,
										uid: collabUid,
                                        name: collabName,
										domains: this.selectedDomains,
										accessLevels: this.accessLevels,
										allowAll: this.allowAll,
										created: new Date().toISOString(),
										status: 'pending'
									});
									await db.collection('users').doc(this.user.uid).update(userData);
									this.$http.post('/collaborator/send_request', {
										grant_type: "token",
										collaborator: {
											email: this.email,
											collaboratorName: (isSignUp === '0') ? collabName : '',
											uid: collabUid,
											domains: this.selectedDomains,
											created: new Date().toISOString(),
											status: 'pending'
										},
										signUpHref: 'https://' + window.location.hostname + '/signup/' +
												crypto.AES.encrypt(this.user.uid, this.aesSecret).toString().split('/').join('Por21Ld') + '/'
												+ crypto.AES.encrypt(this.email, this.aesSecret).toString().split('/').join('Por21Ld'),
										supervisorName: this.user.firstName + ' ' + this.user.lastName,
										loginHref: 'https://' + window.location.hostname,
										isLogin: (isSignUp === '0') ? '1' : '0'
									}).then(() => {

                    this.addLog({
                      message: `New collaboration request has been sent to ${this.email}`,
                      level:  "success"
                    })
										swal({
											title: "Success!",
											html: 'Your collaboration request has been sent to <b>' + this.email + '</b>',
											type: "success",
											confirmButtonText: "OK",
											confirmButtonColor: "#6ACF98"
										});
                                        this.email = '';
                                        this.selectedDomains = [];
										/* eslint-disable */
										$('#createCollaborator').modal('hide');
										/* eslint-disable */
										this.$emit('update-list');
									}).catch(e => {
                    this.addLog({
                      message: `Error in sending collaboration request to ${this.email}`,
                      level:  "error"
                    })
										console.log(e.response);
										// Show error message to the user that the new plan has been added with pending status
										swal({
											title: "Something went wrong!",
											text: e.response.message,
											type: "error",
											confirmButtonText: "Try Again!",
											confirmButtonColor: "#EE8057"
										});
									}).finally(() => {
										this.action = null;
									})
								});
								return false;
							}
						});
					}
				});

			}
		}
	};
</script>

<style>
	.multiselect__option--highlight{
		background: #5a7cfd !important;
	}
	.multiselect__option--highlight:after{
		background: #5a7cfd !important;
	}
	.multiselect__tag{
		background: #5a7cfd !important;
	}
	.multiselect__tag-icon:hover{
		background: red !important;
	}
	.multiselect__tag-icon:after {
		color: white !important;
	}
</style>
